import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppSiteGroupsAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
        multiple
        label="Site Groups"
        placeholder="Your groups of sites"
        urlAjax={`${BACKEND_APIS.CRUD}/user/sites_group?selectorFormat=true`}
        {...props}
    />
}
